module.exports = __webpack_public_path__ + "static/media/passeio-partitura.0e6e0125.png";